module.exports = __webpack_public_path__ + "static/Depositphotos_25309161_s-2019-d5bf6050ae74d588c48a146774d211fd.jpg";